import { gql } from '@apollo/client';

export const GET_COMPANY_IDS = gql`
  query GetCompanyIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    companies(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`;

export const GET_COMPANIES = gql`
  query GetCompanies(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    companies(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      name
      phones {
        value
      }
      emails {
        value
      }
      contactAddress {
        street1
        street2
        city
        state
        zip
        zipExt
      }
    }
  }
`;

export type CompanyItem = {
  id: string;
  name: string;
  phones: {
    value: string;
  };
  emails: {
    value: string;
  };
  contactAddress?: {
    street1: string;
    street2: string;
    city: string;
    state: string;
    zip: string;
    zipExt: string;
  };
};
